import '../App.scss';
import AuthConfirmCaiPreviewPage from '../pages/auth-confirm/AuthConfirmCaiPreviewPage';
import AuthConfirmClaimPage from "../pages/auth-confirm/AuthConfirmClaimPage";
import AuthConfirmCtpNumberPage from '../pages/auth-confirm/AuthConfirmCtpNumberPage';
import AuthConfirmEndCancelPage from "../pages/auth-confirm/AuthConfirmEndCancelPage";
import AuthConfirmEndProcessSuccessPage from '../pages/auth-confirm/AuthConfirmEndProcessSuccessPage';
import AuthConfirmEndTokenExpiredPage from '../pages/auth-confirm/AuthConfirmEndTokenExpiredPage';
import AuthConfirmUploadDocPage from '../pages/auth-confirm/AuthConfirmUploadDocPage';
import ChooseSignatureAuthenticationPage from '../pages/ChooseSignatureAuthenticationPage';
import EndProcedureCancelledPage from '../pages/EndProcedureCancelledPage';
import EndSignatureForwardSuccessPage from '../pages/EndSignatureForwardSuccessPage';
import EndTokenExpiredLinearPage from '../pages/linear/EndTokenExpiredLinearPage';
import RealtimeAccettazioneCaiPageLinear from '../pages/linear/RealtimeAccettazioneCaiPageLinear';
import { ConfirmAuthBreadcrumbTitles, RouteType } from "../types/commonTypes";

export const AUTH_CONFIRM_BASE_ROUTH = 'auth-confirm'

export const AUTH_CONFIRM_PATHS = {
    AUTHORIZE_CONFIRM_CLAIM: "authorize-confirm-claim",
    AUTHORIZE_CONFIRM_CTP_NUMBER: "authorize-confirm-ctp-number",
    AUTHORIZE_CONFIRM_END_CANCEL: "authorize-confirm-end_cancel",
    AUTHORIZE_CONFIRM_CAI_PREVIEW: "authorize-confirm-cai-preview",
    AUTHORIZE_CONFIRM_UPLOAD_DOC: "authorize-confirm-upload-doc",
    AUTHORIZE_CONFIRM_END_PROCESS_SUCCESS: "authorize-confirm-end-process-success",
    AUTHORIZE_CONFIRM_TOKEN_EXPIRED: "authorize-confirm-token-expired",
    AUTHORIZE_CHOOSE_SIGNATURE_AUTHENTICATION: "authorize-choose-signature-authentication",
    AUTHORIZE_END_SIGNATURE_FORWARD_SUCCESS: "authorize-end-signature-forward-success",
    AUTHORIZE_PROCEDURE_CANCELED: "authorize-procedure-canceled",
    AUTHORIZE_LINEAR_REALTIME_ACCETTAZIONE_CAI_PAGE: "authorize-linear-realtime-accettazione-cai-page"
}

export const AUTH_CONFIRM_ROUTES: RouteType[] = [{
    path: AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_CLAIM,
    element: <AuthConfirmClaimPage />,
    tqPageName: 'cai:incidente rilevato controparte'
},
{
    path: AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_END_CANCEL,
    element: <AuthConfirmEndCancelPage />,
    tqPageName: 'cai:procedura interrotta'
}, {
    path: AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_CTP_NUMBER,
    element: <AuthConfirmCtpNumberPage />,
    hasBreadcrumb: false,
    breadcrumbIndex: 1,
    breadcrumbTitles: ConfirmAuthBreadcrumbTitles,
    defaultBackPath: AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_CLAIM,
    backBaseRoute: AUTH_CONFIRM_BASE_ROUTH
},
{
    path: AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_CAI_PREVIEW,
    element: <AuthConfirmCaiPreviewPage />,
    hasBreadcrumb: true,
    breadcrumbIndex: 1,
    breadcrumbTitles: ConfirmAuthBreadcrumbTitles,
    defaultBackPath: AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_CLAIM,
    backBaseRoute: AUTH_CONFIRM_BASE_ROUTH,
    tqPageName: 'cai:cai:constatazione amichevole controparte'
}, {
    path: AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_UPLOAD_DOC,
    element: <AuthConfirmUploadDocPage />,
    hasBreadcrumb: true,
    breadcrumbIndex: 2,
    breadcrumbTitles: ConfirmAuthBreadcrumbTitles,
    defaultBackPath: AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_CAI_PREVIEW,
    backBaseRoute: AUTH_CONFIRM_BASE_ROUTH,
    tqPageName: 'cai:cai:documento di riconoscimento'
}, {
    path: AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_END_PROCESS_SUCCESS,
    element: <AuthConfirmEndProcessSuccessPage />,
    tqPageName: 'cai:cai:conclusione ok'
}, {
    path: AUTH_CONFIRM_PATHS.AUTHORIZE_END_SIGNATURE_FORWARD_SUCCESS,
    element: <EndSignatureForwardSuccessPage />,
    //tqPageName: 'cai:cai:conclusione ok'
}, {
    path: AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_TOKEN_EXPIRED,
    element: <AuthConfirmEndTokenExpiredPage />,
    tqPageName: 'cai:comunicazione scaduta'
}, {
    path: AUTH_CONFIRM_PATHS.AUTHORIZE_CHOOSE_SIGNATURE_AUTHENTICATION,
    hasBreadcrumb: true,
    element: <ChooseSignatureAuthenticationPage />,
    breadcrumbTitles: ConfirmAuthBreadcrumbTitles,
    breadcrumbIndex: 2,
    defaultBackPath: AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_CAI_PREVIEW,
    backBaseRoute: AUTH_CONFIRM_BASE_ROUTH,
    //tqPageName: 'cai:flusso concluso'
}, {
    path: AUTH_CONFIRM_PATHS.AUTHORIZE_PROCEDURE_CANCELED,
    element: <EndProcedureCancelledPage />
}]

//linear
export const LINEAR_AUTH_CONFIRM_ROUTES: RouteType[] = [{
    path: AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_CLAIM,
    element: <AuthConfirmClaimPage />
}, {
    path: AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_END_CANCEL,
    element: <AuthConfirmEndCancelPage />
}, {
    path: AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_CAI_PREVIEW,
    element: <AuthConfirmCaiPreviewPage />
}, {
    path: AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_UPLOAD_DOC,
    element: <AuthConfirmUploadDocPage />
}, {
    path: AUTH_CONFIRM_PATHS.AUTHORIZE_CONFIRM_TOKEN_EXPIRED,
    element: <EndTokenExpiredLinearPage isCtp={true} />
}, {
    path: AUTH_CONFIRM_PATHS.AUTHORIZE_CHOOSE_SIGNATURE_AUTHENTICATION,
    element: <ChooseSignatureAuthenticationPage />
}, {
    path: AUTH_CONFIRM_PATHS.AUTHORIZE_LINEAR_REALTIME_ACCETTAZIONE_CAI_PAGE,
    element: <RealtimeAccettazioneCaiPageLinear />
}]

